import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-medium tracking-tight ' +
    'tabular-nums transition-colors duration-150 ease-out-quart ' +
    'focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary/10 text-primary ring-1 ring-inset ring-primary/20',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground',
        outline: 'text-foreground border-border',
        success:
          'border-transparent bg-success/10 text-success ring-1 ring-inset ring-success/20',
        warning:
          'border-transparent bg-warning/10 text-warning ring-1 ring-inset ring-warning/30',
        destructive:
          'border-transparent bg-destructive/10 text-destructive ring-1 ring-inset ring-destructive/30',
        muted:
          'border-transparent bg-muted text-muted-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
